import React from 'react';

interface ErrorStateProps {
  isMimicking: boolean;
  error: string | null;
  onRetry: () => void;
}

export const ErrorState: React.FC<ErrorStateProps> = ({ isMimicking, error, onRetry }) => (
  <div
    className={`min-h-screen bg-gray-50 flex items-center justify-center ${isMimicking ? 'mt-[52px]' : ''}`}
  >
    <div className="text-center max-w-md mx-auto px-4">
      <div className="bg-red-50 border border-red-200 rounded-lg p-6">
        <h2 className="text-lg font-semibold text-red-800 mb-2">Preview Error</h2>
        <p className="text-red-700 mb-4">{error}</p>
        <div className="space-y-3">
          <button onClick={onRetry} className="btn-primary">
            Try Again
          </button>
          <button onClick={() => window.close()} className="btn-secondary ml-2">
            Close Preview
          </button>
        </div>
      </div>
    </div>
  </div>
);
